import * as React from "react";

import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/styles";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { Box, Fab } from "@material-ui/core";
import { BaseMuiTheme, colors } from "swyft-react-core";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import { LuckyOrange } from "./LuckyOrange";
import { Termly } from "./Termly";
import { Provesrc } from "./Provesrc";
import OverrideTheme from "./OverrideTheme";
import { useLocation } from "react-router";
import { NewFooter } from "./NewFooter";
import { ScrollTopButton } from "./ScrollTopButton";
import { KeyboardArrowUp } from "@material-ui/icons";

const breakpoints = createBreakpoints({});

BaseMuiTheme.palette.primary.main = colors.darkGrey;
BaseMuiTheme.palette.text.primary = colors.darkGrey;

BaseMuiTheme.typography.h5 = {
  fontSize: "1.75rem",
  fontWeight: "bold",
  [breakpoints.up("md")]: {
    fontSize: "3.5rem"
  }
};

const isNewRoute = (pathname: string): boolean => {
  const quotePagePattern = new RegExp("^\\/quote\\/[0-9a-fA-F\\-]{36}$");
  const myQuotesRoutes = pathname.includes("my-quotes");
  const outcomeRoutes = pathname.includes("outcome");
  const checkoutRoutes = pathname.includes("checkout");
  const paymentRoutes = pathname.includes("payment") && !pathname.includes("payment-details");

  return quotePagePattern.test(pathname) || checkoutRoutes || myQuotesRoutes || outcomeRoutes || paymentRoutes;
};

const Layout = (props: { children?: React.ReactNode }) => {
  const location = useLocation();
  const newRoute = isNewRoute(location.pathname);

  return (
    <ThemeProvider theme={BaseMuiTheme}>
      <Termly />
      <LuckyOrange />
      <Provesrc />
      <CssBaseline />
      {!newRoute && <NavBar />}

      <Box overflow="hidden">
        <>{props.children}</>
      </Box>
      {newRoute && (
        <ScrollTopButton>
          <Fab color="secondary" size="small" aria-label="scroll back to top">
            <KeyboardArrowUp htmlColor="#160337" />
          </Fab>
        </ScrollTopButton>
      )}
      <OverrideTheme>{!newRoute ? <Footer /> : <NewFooter />}</OverrideTheme>
      <svg
        style={{ visibility: "hidden", position: "absolute" }}
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="round">
            <feGaussianBlur in="SourceGraphic" stdDeviation="4" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9" result="goo" />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
    </ThemeProvider>
  );
};

export default Layout;
